import { render, staticRenderFns } from "./incomeStockMovementDetailBox.vue?vue&type=template&id=76f4c2b4&"
import script from "./incomeStockMovementDetailBox.vue?vue&type=script&lang=ts&"
export * from "./incomeStockMovementDetailBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports